import { Typography } from "@mui/material";
import { getSavingsPlanCommonColumns } from "./common/getSavingsPlanCommonColumns";
import { SavingsPlanCoverageDataWithId } from "../../../../../../utils/types";
import { SavingsPlanResourceType } from "../../../../../../../../../../services/cloudchipr.api";
import { savingsPlansResourceTypeNames } from "../../../../../../utils/constants/labels";
import { ColumnSetupType } from "../../../../../../../../../../storybook/data-grid/utils/types/types";

export const savingsPlanGroupedByResourceTypeColumns: ColumnSetupType<SavingsPlanCoverageDataWithId>[] =
  [
    {
      id: "resource_type",
      header: "Resource Type",
      accessorKey:
        "resource_type.resource_type" as keyof SavingsPlanCoverageDataWithId,
      cell: ({ row }) => {
        const rt = row.original.resource_type
          ?.resource_type as SavingsPlanResourceType;

        return (
          <Typography variant="body2" textTransform="capitalize">
            {savingsPlansResourceTypeNames[rt]}
          </Typography>
        );
      },
    },
    {
      id: "instance_family",
      accessorKey:
        "resource_type.instance_family" as keyof SavingsPlanCoverageDataWithId,
      header: "Instance Family",
      cell: ({ row }) => row.original.resource_type?.instance_family ?? "-",
    },
    {
      id: "region",
      accessorKey:
        "resource_type.region" as keyof SavingsPlanCoverageDataWithId,
      header: "Region",
      cell: ({ row }) => row.original.resource_type?.region ?? null,
    },
    ...getSavingsPlanCommonColumns("resource_type"),
  ];
